import s from './style.module.scss';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import pageImg from '@/assets/images/default_site.webp';
import { contentType } from '@/utils/Page/constant';
import SiteImage from '@/components/SiteImage';
import FileType from '@/components/FileType';
const titleMap = {
    retrieval: '参考资料',
    web_search: '相关网页'
};

const DataList = (props) => {
    const { dataList, onClose, fileType } = props;
    const onClickPage = (page) => {
        console.log(page);
        window.open(page.url);
    };
    const onClickFile = (file) => {
        console.log(file);
    };
    return (
        <div className={[`${s['modal-box']} ${s['data-list-box']}`]}>
            <div className={s['modal-action']}>
                <span className={s['title']}>{titleMap[fileType]}</span>
                <span
                    className={s['close']}
                    onClick={() => {
                        onClose();
                    }}
                >
                    <MyIcon type="icon-a-guanbi31"></MyIcon>
                </span>
            </div>
            <div className={s['scroll-box']}>
                <Display show={fileType === contentType.retrieval}>
                    <div className={s['list-item-box']}>
                        {dataList.map((ele, index) => {
                            return (
                                <div
                                    className={[`${s['file-list-item']} `]}
                                    onClick={() => {
                                        onClickFile(ele);
                                    }}
                                    key={index}
                                >
                                    <FileType showType={false} fileName={ele.title}></FileType>
                                    <span className={[`${s['file-title']} ellipsis-2`]}>
                                        {ele.tag}.{ele.title}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </Display>
                <Display show={fileType === contentType.web_search}>
                    <div className={s['list-item-box']}>
                        {dataList.map((ele, index) => {
                            return (
                                <div
                                    className={s['web-list-item']}
                                    onClick={() => {
                                        onClickPage(ele);
                                    }}
                                    key={index}
                                >
                                    <div className={[`${s['site-name']} ellipsis-2`]}>
                                        <span className={s['left']}>
                                            <span className={s['site-icon']}>
                                                <SiteImage src={ele.icon} alt="" errimg={pageImg} />
                                            </span>
                                            <span className={[`${s['site-title']}  ellipsis-1`]}>{ele.site_name}</span>
                                        </span>

                                        <span className={s['citation']}>{ele.tag}</span>
                                    </div>
                                    <div className={[`${s['page-title']} ellipsis-2`]}>{ele.title}</div>
                                    <div className={[`${s['page-summary']} ellipsis-2`]}>{ele.summary}</div>
                                </div>
                            );
                        })}
                    </div>
                </Display>
            </div>
        </div>
    );
};

export default DataList;
